/**
 * Application configuration derived from build-time environment variables.
 *
 * VITE_ENVIRONMENT is set in CI (see .github/workflows/deploy-marketing.yml):
 * - dev build: VITE_ENVIRONMENT=dev
 * - prod build: VITE_ENVIRONMENT=prod
 *
 * Locally (npm run dev), VITE_ENVIRONMENT is undefined, so we default to 'dev'.
 */

export type Environment = 'dev' | 'prod';

export const environment: Environment =
  (import.meta.env.VITE_ENVIRONMENT as Environment) || 'dev';

export const isDev = environment === 'dev';

/**
 * Base URL for the leads/contact API (Corp Ops Functions)
 *
 * Set via VITE_LEADS_API_URL environment variable:
 * - Local: defaults to http://localhost:7072 (via .env.local or just the fallback)
 * - CI builds: set in workflow (e.g., VITE_LEADS_API_URL=https://corp-ops-func-internal.azurewebsites.net)
 */
export const leadsApiBaseUrl =
  import.meta.env.VITE_LEADS_API_URL || 'http://localhost:7072';
